import { lazy, Suspense, useContext } from "react";
import PropTypes from "prop-types";

import Header from "./improved-header";
import CLAFooter from "./footer";
import Footer from "./improved-footer";
import GenericHeader from "../news/headers/generic-header";
import { getNewsPath } from "../../lib/helpers";
import navHoltUndergrad from "../../lib/data/nav-holt-undergrad";
import footerHoltUndergrad from "../../lib/data/footer-holt-undergrad";
import footerHoltGraduate from "../../lib/data/footer-holt-graduate";
import NavGraduateStudies from "../page/page-components/nav-graduate-studies";
import CLAHeader from "./header";
const NewsBreadcrumb = lazy(() => import("../news/news-breadcrumb"));

/**
 * Get Header Layout Variant
 * @param type
 * @param cssClass
 * @param page
 * @param section
 * @param miscLinks
 * @param ctas
 * @returns {JSX.Element}
 * @constructor
 */
function HeaderLayout({ type, cssClass, page, section, miscLinks, ctas }) {
  switch (type) {
    case "CLALayout":
      return <Header
          section={section}
          cssClass={cssClass}
          page={page}
          nav={navHoltUndergrad}
          miscLinks={miscLinks}
          ctas={ctas}
      />;
    case "GraduateStudiesLayout":
      return (
        <NavGraduateStudies
          cssClass={cssClass}
          page={page}
          miscLinks={miscLinks}
          ctas={ctas}
        />
      );
    default:
      return (
        <Header
          section={section}
          cssClass={cssClass}
          page={page}
          nav={navHoltUndergrad}
          miscLinks={miscLinks}
          ctas={ctas}
        />
      );
  }
}

/**
 * Get Footer Layout Variant
 * @returns {JSX.Element}
 * @constructor
 */
function FooterLayout(props) {
  switch (props.type) {
    case "CLALayout":
      return <CLAFooter />;
    case "GraduateStudiesLayout":
      return <Footer {...props} />;
    default:
      return <Footer {...props} />;
  }
}

/**
 * RollinsLayout
 * @param location
 * @param isNews
 * @param isNewsPost
 * @param isTopic
 * @param title
 * @param section
 * @param children
 * @param cssClass
 * @param page
 * @param noTopics
 * @param type
 * @returns {JSX.Element}
 * @constructor
 */
function RollinsLayout({
  location,
  isNews,
  isNewsPost,
  isTopic,
  title,
  section,
  children,
  cssClass,
  page,
  noTopics,
  type,
}) {
  const isCLA =
    section?.sectionSlug === undefined || section.sectionSlug.current === "cla";
  let layoutType = type;

  if (isCLA) {
    layoutType = "CLALayout";
  }

  const footerNavProps =
    type === "GraduateStudiesLayout" ? footerHoltGraduate : footerHoltUndergrad;

  return (
    <div className="flex flex-col min-h-screen">
      <HeaderLayout
        type={layoutType}
        cssClass={cssClass}
        page={page}
        section={section}
        miscLinks={footerNavProps.miscLinks}
        ctas={footerNavProps.ctas}
      />
      <main>
        {isNews && (
          <GenericHeader section={section} noTopics={noTopics}>
            {(isTopic || isNewsPost) && (
              <Suspense fallback={null}>
                <NewsBreadcrumb newsPath={getNewsPath({ section })} />
              </Suspense>
            )}
            <h1>{title}</h1>
          </GenericHeader>
        )}
        {children}
      </main>
      <FooterLayout type={layoutType} section={section} {...footerNavProps} />
    </div>
  );
}

RollinsLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RollinsLayout;
